import * as React from 'react';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { Cell, Column, MobileLabel, Table, TitleCell, TitleColumn } from './AssetsDetails.styled';

const labels = [
    'Asset:',
    '24H change:',
    'Current price:',
    'Asset holders:',
    'Payments volume:',
    'Trading volume:',
    'First transaction:',
    'TVL on Aquarius:',
    'Total AMM volume:',
    'Daily avg. AMM volume:',
    'More info:',
];

const AssetsDetailsLoading = () => (
    <Table aria-hidden="true">
        <TitleColumn>
            {labels.map(label => (
                <TitleCell key={label}>{label}</TitleCell>
            ))}
        </TitleColumn>
        {[0, 1].map(index => (
            <Column key={index}>
                {labels.map((label, i) => (
                    <Cell key={label}>
                        <MobileLabel>{label}</MobileLabel>
                        <Bar
                            $width={i === 0 ? '9rem' : '7rem'}
                            $height={i === 0 ? '2.4rem' : '1.4rem'}
                        />
                    </Cell>
                ))}
            </Column>
        ))}
    </Table>
);

export default AssetsDetailsLoading;
